import { useEffect } from "react";
import { BOOLEAN_CHOICES, E_MONEY_VALUE } from "../../../constants/globals";
import HeaderStep from "../../../Pages/AddOrEditPartner/PartnerSteps/HeaderStep";
import DropdownForm from "../../Form/DropdownForm";
import FormField from "../../Form/FormField";

const PackageStepTwo = ({
  errors,
  touched,
  handleBlur,
  setFieldValue,
  handleChange,
  values,
}) => {
  const totalPriceInEM = Math.max(
    0,
    +values.courses_price + +values.registration_price
  );
  const totalPriceInEG = Math.max(0, +totalPriceInEM * E_MONEY_VALUE);

  useEffect(() => {
    if (!isNaN(totalPriceInEM)) {
      setFieldValue("total_price_em", totalPriceInEM);
      setFieldValue("total_price_eg", totalPriceInEG);
    }
  }, [totalPriceInEM, totalPriceInEG, setFieldValue]);

  return (
    <div className="card !tw-rounded-xl">
      <div className="tw-rounded-t-xl tw-overflow-hidden">
        <HeaderStep
          stepNumber={2}
          stepName={"Prices & Commission Data"}
          stepText="Part"
        />
      </div>
      <div className="card-body tw-shadow-xl tw-rounded-xl">
        <div className="row">
          {/* registration_price*/}
          <FormField
            type="number"
            name={"registration_price"}
            label={"registration price E.M"}
            placeholder={"registration price"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.registration_price}
          />
          {/* courses_price*/}
          <FormField
            type="number"
            name={"courses_price"}
            label={"courses price E.M"}
            placeholder={"courses price E.M"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.courses_price}
          />
          {/* total_price_em*/}
          <FormField
            type="number"
            readOnly
            name={"total_price_em"}
            label={"total price E.M"}
            placeholder={"total price E.M"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.total_price_em}
          />
          {/* total_price_eg*/}
          <FormField
            type="number"
            readOnly
            name={"total_price_eg"}
            label={"total price E.G"}
            placeholder={"total price E.G"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.total_price_eg}
          />

          {/*is_pv_active */}
          <DropdownForm
            handleChange={handleChange}
            name={"is_pv_active"}
            dataToDrop={BOOLEAN_CHOICES}
            error={errors.is_pv_active}
            touched={touched.is_pv_active}
            label={"is pv active"}
            placeholder={"is pv active"}
            gridStyle="col-sm-6"
          />

          {/*is_pv_upliner_active */}
          <DropdownForm
            handleChange={handleChange}
            name={"is_pv_upliner_active"}
            dataToDrop={BOOLEAN_CHOICES}
            error={errors.is_pv_upliner_active}
            touched={touched.is_pv_upliner_active}
            label={"is pv upliner active"}
            placeholder={"is pv upliner active"}
            gridStyle="col-sm-6"
          />

          {/* value_of_direct_comission*/}
          <FormField
            type="number"
            name={"value_of_direct_comission"}
            label={"value of direct comission"}
            placeholder={"value of direct comission"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.value_of_direct_comission}
          />
          {/* Installment Fees*/}
          <FormField
            type="number"
            name={"installment_fees"}
            label={"Installment Fees"}
            placeholder={"value of installment fees"}
            touched={touched}
            errors={errors}
            col_md={"6"}
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            value={values.installment_fees}
          />

          {/* activate_now */}
          <DropdownForm
            handleChange={handleChange}
            name={"activate_now"}
            dataToDrop={BOOLEAN_CHOICES}
            error={errors.activate_now}
            touched={touched.activate_now}
            label={"activate now"}
            placeholder={"activate now"}
            gridStyle="col-sm-6"
          />
        </div>
      </div>
    </div>
  );
};

export default PackageStepTwo;
